export default {
  massiveHeadline: {
    fontSize: '90px',
    textTransform: 'uppercase',
    fontFamily: 'rift-soft, sans-serif',
    margin: 0,
  },
  shareCount: {
    fontSize: '48px',
    textTransform: 'uppercase',
    fontFamily: 'rift-soft, sans-serif',
    margin: 0,
  },
  shareDesc: {
    letterSpacing: '0.89px',
    fontSize: '16px',
    textTransform: 'uppercase',
    fontFamily: 'rift-soft, sans-serif',
    margin: 0,
  },
  heroHeadline: {
    fontSize: '52px',
    textTransform: 'uppercase',
    fontFamily: 'rift-soft, sans-serif',
    margin: '0 0 10px 0',
    background: '-webkit-linear-gradient(right, #F7256B, #BA38A0)',
    '-webkitBackgroundClip': 'text',
    '-webkitTextFillColor': 'transparent'
  },
  headline: {
    fontSize: '40px',
    textTransform: 'uppercase',
    fontFamily: 'rift-soft, sans-serif',
    margin: '0 0 10px 0'
  },
  heavyHeadline: {
    fontSize: '40px',
    fontWeight: 500,
    textTransform: 'uppercase',
    fontFamily: 'rift-soft, sans-serif',
    margin: '0 0 10px 0'
  },
  gearBacking: {
    fontFamily: 'AvenirLTStd-Heavy, sans-serif',
    fontSize: '90px',
    fontWeight: 900,
    margin: 0
  },
  largeness: {
    fontSize: '40px',
    textTransform: 'uppercase',
    fontWeight: 600,
    margin: '6px 0 8px 0',
    fontFamily: 'AvenirLTStd-Medium, sans-serif',
    letterSpacing: '1px'
  },
  mediumness: {
    fontSize: '22px',
    fontWeight: 400,
    margin: '6px 0 8px 0'
  },
  subheadline: {
    fontSize: '17px',
    margin: 0,
    lineHeight: '25px'
  },
  subheadlineLarge: {
    fontSize: '22px',
    margin: 0,
    lineHeight: '31px'
  },
  p: {
    margin: 0,
    lineHeight: '26px',
  },
  pExtra: {
    fontSize: '20px',
    margin: 0,
    lineHeight: '26px',
  },
  pBook: {
    margin: 0,
    fontWeight: 600,
    lineHeight: '26px'
  },
  pBold: {
    fontWeight: 700,
    lineHeight: '26px'
  },
  pBoldUpper: {
    fontWeight: 700,
    lineHeight: '26px',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    fontSize: '14px'
  },
  pTiny: {
    margin: 0,
    fontSize: '12px'
  },
  smallTracked: {
    fontSize: '12px',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    fontFamily: 'AvenirLTStd-Heavy, sans-serif',
    margin: 0
  },
  countdownNumber: {
    fontSize: '26px',
    margin: 0
  },
  countdownLetter: {
    fontSize: '14px',
    fontFamily: 'AvenirLTStd-Heavy, sans-serif',
    margin: '0 1px 0 0'
  },
  qHeader: {
    fontSize: '18px'
  },
  demiHeadline: {
    lineHeight: '30px',
    fontSize: '22px',
    fontWeight: 600
  },
  textLeft: {
    textAlign: 'left'
  },
  textRight: {
    textAlign: 'right'
  },
};



// WEBPACK FOOTER //
// ./src/stylesheet/copy.js